import { Box, BoxProps, SxProps, Tooltip, TooltipProps } from '@mui/material'
import { Theme } from '@mui/system'
import { useBoolean } from 'lib/hooks'
import { useEffect } from 'react'
import CopyToClipboard from 'react-copy-to-clipboard'
import { useTranslation } from 'react-i18next'

type Props = {
  children: React.ReactNode
  text: string
  tooltipPlacement?: TooltipProps['placement']
  containerProps?: BoxProps
  arrow?: boolean
  title?: string
  tooltipSx?: SxProps<Theme>
}

export const CopyText = ({
  children,
  tooltipPlacement,
  text,
  containerProps,
  arrow = true,
  title,
  tooltipSx,
}: Props) => {
  const { t } = useTranslation()

  const copied = useBoolean(false)

  const copyTitle = title ?? t('common.click_to_copy')

  useEffect(() => {
    if (copied.isTrue) {
      setTimeout(() => {
        copied.setFalse()
      }, 3000)
    }
  }, [copied])

  return (
    <CopyToClipboard text={text} onCopy={copied.setTrue}>
      <Tooltip
        arrow={arrow}
        title={copied.isTrue ? t('common.copied') : copyTitle}
        placement={tooltipPlacement}
        TransitionProps={{
          onExited: copied.setFalse,
        }}
        componentsProps={{
          tooltip: {
            sx: tooltipSx,
          },
        }}
      >
        <Box
          {...containerProps}
          sx={{ cursor: 'pointer', ...containerProps?.sx }}
        >
          {children}
        </Box>
      </Tooltip>
    </CopyToClipboard>
  )
}
